import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

export const PostQuantitySelector = ({ onFinalize, isReadOnly = false, selectedValue = null, availableArts = null }) => {
  const { t } = useTranslation();
  const [selectedQuantity, setSelectedQuantity] = useState(null);
  const [isFinalizing, setIsFinalizing] = useState(false);
  const options = [5, 10, 15, 20];

  useEffect(() => {
    // Treat the answer from history, which could be a string, number, or array of strings.
    if (selectedValue !== null && selectedValue !== undefined && selectedValue !== '') {
      const parsedValue = parseInt(
        Array.isArray(selectedValue) ? selectedValue[0] : selectedValue, 
        10
      );
      if (!isNaN(parsedValue)) {
        setSelectedQuantity(parsedValue);
      }
    }
  }, [selectedValue]);

  const isQuantityInsufficient = (quantity) =>
    availableArts !== null && quantity > availableArts;

  const handleSelect = (quantity) => {
    if (isReadOnly || isFinalizing || selectedValue !== null) return;
    if (isQuantityInsufficient(quantity)) return;
    setSelectedQuantity(quantity);
  };

  const handleFinalize = () => {
    if (
      isReadOnly ||
      isFinalizing ||
      !selectedQuantity ||
      selectedValue !== null ||
      isQuantityInsufficient(selectedQuantity)
    ) return;
    setIsFinalizing(true);
    onFinalize && onFinalize(selectedQuantity);
  };

  const parsedSelectedValue = (() => {
    if (selectedValue !== null && selectedValue !== undefined && selectedValue !== '') {
      const parsed = parseInt(
        Array.isArray(selectedValue) ? selectedValue[0] : selectedValue,
        10,
      );
      return isNaN(parsed) ? null : parsed;
    }
    return null;
  })();

  const isInteractive =
    !isReadOnly &&
    !isFinalizing &&
    parsedSelectedValue === null;
  const selectedQuantityIsInsufficient = isQuantityInsufficient(selectedQuantity);

  return (
    <div className={styles.container}>
      <span className={styles.title}>{t('chatsocket.post_quantity.title')}</span>
      
      <div className={styles.optionsGrid}>
        {options.map((quantity) => {
          const isSelected = selectedQuantity === quantity;
          const isInsufficient = isQuantityInsufficient(quantity);
          return (
            <div
              key={quantity}
              className={`${styles.option} ${isSelected ? styles.selected : ''} ${!isInteractive || isInsufficient ? styles.disabledOption : ''} ${isInsufficient ? styles.insufficientOption : ''}`}
              onClick={() => handleSelect(quantity)}
              title={isInsufficient ? t('chatsocket.post_quantity.insufficient_tooltip', { available: availableArts }) : undefined}
            >
              <span className={styles.optionText}>{t('chatsocket.post_quantity.arts_display', { count: quantity })}</span>
              {isSelected && (
                <svg
                  className={styles.checkIcon}
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 6L9 17L4 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>
          );
        })}
      </div>

      <button
        className={styles.finalizeButton}
        onClick={handleFinalize}
        disabled={!isInteractive || !selectedQuantity || selectedQuantityIsInsufficient}
      >
        {isFinalizing
          ? t('chatsocket.post_quantity.finalizing')
          : selectedQuantityIsInsufficient
            ? t('chatsocket.post_quantity.insufficient_balance')
            : t('chatsocket.post_quantity.finalize')}
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 6L9 17L4 12"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};
